// BOT-1710: while a franchise's menu propagation is on, the Rails API marks the records it mirrors
// into a franchisee with franchise_managed and franchise_name, drops the owned fields from updates
// and refuses deletes. A record serialized without the key (a storefront or lighter endpoint) is not
// managed as far as that response knows.

// What a franchisee can still change on a managed record. Everything else is the franchise's, and
// the API strips it, so the dashboard does not send stale copies of it either.
export const FRANCHISE_EDITABLE_PRODUCT_KEYS = [
  'has_quantity_limit',
  'set_quantity_changes_attributes',
  'product_price_list_pairs_attributes',
  'replace_with_product_id'
]
export const FRANCHISE_EDITABLE_OPTION_KEYS = ['id', 'has_quantity_limit', 'set_quantity_changes_attributes']
export const FRANCHISE_EDITABLE_PAIR_KEYS = ['product_attributes']

// Accepts a JSONAPI record or a plain availability row (which carries the flag at the top level).
export const isFranchiseManaged = record =>
  Boolean(record?.attributes ? record.attributes.franchise_managed : record?.franchise_managed)

export const franchiseLockText = franchiseName => `Managed by ${franchiseName || 'the franchise'}`

export const franchiseRecordLockText = record => franchiseLockText(record?.attributes?.franchise_name)

// A later, unrelated request can overwrite the store's copy of a record with a version serialized
// without franchise_managed (a sparse-field or search response). That omission says nothing about
// the lock. Only a record that carries the key can change what a page remembers.
export const nextFranchiseManaged = (previous, record) => {
  const attributes = record?.attributes
  if (!attributes || !('franchise_managed' in attributes)) return previous
  return attributes.franchise_managed ? { franchiseName: attributes.franchise_name ?? null } : null
}

export const franchiseEditable = (attributes, keys) =>
  Object.fromEntries(Object.entries(attributes).filter(([key]) => keys.includes(key)))
